(function ($, Drupal, once) {

  'use strict';

  /**
   * This works with the breakout-* CSS utility classes.
   */
  Drupal.behaviors.promutuel_breakoutToFooter = {
    attach: function attach(context) {

      // Get the element on the footer that may need to become a breakout neighbour.
      const foot = document.querySelector('footer .footer__top');
      // Get the main element (the one just before the footer).
      const main = foot?.parentNode?.previousElementSibling;

      $(once('promutuel_breakoutToFooter', foot, context)).each(function () {
        let child = main;
        // Traverse the 'last' descendants (last child, last grandchild, etc.) to find a breakout class).
        do {
          const breakoutClassName = [...child.classList].find(name => name.startsWith('breakout-b-') && !name.endsWith('-neighbour'));
          // If a class is indeed found, make the footer a neighbour.
          if (breakoutClassName) foot.classList.add(breakoutClassName + '-neighbour');
        } while (child = child.lastElementChild)
      });
    }
  };
})(jQuery, Drupal, once);
